export default function (params) {
  if (!params.total || params.total == 0 || params.total == 1) return '';

  let segmentedURI = () => {
    let path = document.location.href.split('/');
    return {
      page: path[path.length - 1].indexOf('index') < 0 ? path[path.length - 1].split('?')[0] : '',
      query: path[path.length - 1].split('?')[1] ? path[path.length - 1].split('?')[1] : false
    };
  };

  let query = [];
  if (segmentedURI().query) {
    query = segmentedURI().query.split('&');
    query = $.map(query, (q) => {
      if (q.indexOf('page') < 0) return q;
    });
  }

  let path = `/${segmentedURI().page + '?' + (query.length ? query.join('&') + '&' : '')}`;
  let total = params.total;
  let page = params.page * 1;
  if (page < 1) page = 1;
  if (page > total) page = total;

  let min = page - 5;
  let max = min + 10;

  if (min < 1) max += 1 - min;
  if (max > total) min -= max - total;
  if (min < 1) min = 1;
  if (max > total) max = total;

  let out =
    '<div class="kt-pagination kt-pagination--brand flex-column align-content-end"><ul class="kt-pagination__links">';
  if (page == 1) {
    out += `<li class="kt-pagination__link--first kt-pagination__link--disabled"><span><i class="far fa-angle-double-left"></i></span></li>`;
    out += `<li class="kt-pagination__link--first kt-pagination__link--disabled"><span><i class="far fa-angle-left"></i></span></li>`;
  } else {
    out += `<li class="kt-pagination__link--first"><a href="${path}page=1" data-pagename="${params.pagename}" data-page="1" data-aid="page-${params.pagename}-first" data-navigo><i class="far fa-angle-double-left"></i></a></li>`;
    out += `<li class="kt-pagination__link--first"><a href="${path}page=${page - 1}" data-pagename="${
      params.pagename
    }" data-page="${page - 1}" data-aid="page-${
      params.pagename
    }-prev" data-navigo><i class="far fa-angle-left"></i></a></li>`;
  }

  if (min > 1) out += `<li class="kt-pagination__link--disabled"><span><i class="fal fa-ellipsis-h"></i></span></li>`;

  for (let i = min; i <= max; i++) {
    if (page == i) out += `<li class="kt-pagination__link--active"><a href="javascript:">${i}</a></li>`;
    else
      out += `<li><a href="${path}page=${i}" data-pagename="${params.pagename}" data-page="${i}" data-aid="page-${params.pagename}-${i}" data-navigo>${i}</a></li>`;
  }

  if (max < total)
    out += `<li class="kt-pagination__link--disabled"><span><i class="fa fa-ellipsis-h"></i></span></li>`;

  if (page == total) {
    out += `<li class="kt-pagination__link--last kt-pagination__link--disabled"><span><i class="far fa-angle-right"></i></span></li>`;
    out += `<li class="kt-pagination__link--last kt-pagination__link--disabled"><span><i class="far fa-angle-double-right"></i></span></li>`;
  } else {
    out += `<li class="kt-pagination__link--last"><a href="${path}page=${page + 1}" data-pagename="${
      params.pagename
    }" data-page="${page + 1}" data-aid="page-${
      params.pagename
    }-next" data-navigo><i class="far fa-angle-right"></i></a></li>`;
    out += `<li class="kt-pagination__link--last"><a href="${path}page=${total}" data-pagename="${params.pagename}" data-page="${total}" data-aid="page-${params.pagename}-last" data-navigo><i class="far fa-angle-double-right"></i></a></li>`;
  }

  out += '</ul></div>';
  return out;
}
